import { accountTypes } from '../types';

const initialState = {
    loading: true,
    user: null,
    error: null,
    form: null,
    subscribe: null,
};

export const account = (state = initialState, action) => {
    switch (action.type) {
        case accountTypes.USER_DATA_REQUEST:
            return { ...state, loading: true };
        case accountTypes.USER_DATA_SUCCESS:
            return { ...state, loading: false, ...action.user };
        case accountTypes.USER_DATA_ERROR:
            return { ...state, loading: false, user: null, error: action.error };

        case accountTypes.USER_DATA_CHANGE_REQUEST:
            return { ...state, loading: false, user: { ...state.user, ...action.user }, form: action.form };
        case accountTypes.USER_DATA_CHANGE_SUCCESS:
            return { ...state, loading: false, user: action.user, form: null };
        case accountTypes.USER_DATA_CHANGE_ERROR:
            return { ...state, loading: false, user: state.user, error: action.error };

        case accountTypes.USER_PASSWORD_CHANGE_REQUEST:
            return { ...state, loading: false, user: { ...state.user, password: action.password }, form: action.form };
        case accountTypes.USER_PASSWORD_CHANGE_SUCCESS:
            return { ...state, loading: false, user: action.user, form: null };
        case accountTypes.USER_PASSWORD_CHANGE_ERROR:
            return { ...state, loading: false, user: state.user, error: action.error };

        case accountTypes.USER_SUBSCRIPTIONS_CHANGE_REQUEST:
            return { ...state, loading: false, subscribe: action.subscribe, form: action.form };
        case accountTypes.USER_SUBSCRIPTIONS_CHANGE_SUCCESS:
            return {
                ...state,
                loading: false,
                form: null,
            };
        case accountTypes.USER_SUBSCRIBE_CHANGE_ERROR:
            return { ...state, loading: false, subscribe: state.subscribe, error: action.error };

        case accountTypes.CLEAR:
            return initialState;

        default:
            return state;
    }
};
